export class MakeProductDto {
  groupId: number;
  subGroupId: number;
  selectedProduct: number;
}
